const MultiSelectClassCodeComponent = {
    templateUrl: '/formViewer/component/multiSelectClassCode/multiSelectClassCode.tpl.html',
    controller: 'multiSelectClassCodeController',
    bindings: {
        timeLastModified: '<',
        onSelect: '&?',
        fieldStructure: '<',
        effectiveDate: '<'
    }
};

angular.module('umCore')
    .component('uiMultiSelectClassCode', MultiSelectClassCodeComponent);
